<div class="loader-wrapper" [class.loderhide]="!show">
  <div class="loader-box card-loader">
    <div class="loader card-load">
      <div class="whirly-loader"></div>
    </div>
  </div>
</div>
